import defaultAttributes from '../defaultAttributes';

const SortAsc = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M11 11H15' }],
    ['path', { d: 'M11 15H18' }],
    ['path', { d: 'M11 19H21' }],
    ['path', { d: 'M9 7L6 4L3 7' }],
    ['path', { d: 'M6 6L6 20' }],
  ],
];

export default SortAsc;
